import { render, staticRenderFns } from "./Volunteering.vue?vue&type=template&id=2b591a10&"
import script from "./Volunteering.vue?vue&type=script&lang=js&"
export * from "./Volunteering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports